<template>
  <div class="recurit">
    <div class="pc">
      <img class="banner-pc" src="../../assets/img/bg.jpg" alt />
      <img class="banner-m" src="../../assets/img/m-bg.jpg" alt />

      <div class="container">
        <div class="menu-box row">
          <div class="menu-item col-md-6 col-sm-6 col-xs-12">
            <div class="menu animated fadeUp">
              <img class="navImg" src="../../assets/img/nav2.jpg" alt />
              <div class="nav-title">校园招聘</div>
              <div class="menu-btn" @click="nav('school')">点击进入</div>
            </div>
          </div>
          <div class="menu-item col-md-6 col-sm-6 col-xs-12">
            <div class="menu animated">
              <img class="navImg" src="../../assets/img/nav1.jpg" alt />
              <div class="nav-title">社会招聘</div>
              <div class="menu-btn" @click="nav('agency')">点击进入</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="mobile">
      <div class="fly">
        <img src="../../assets/img/fly.png" alt />
      </div>
      <div class="logo">
        <img src="../../assets/img/logo.png" alt />
      </div>

      <div class="enter-box">
        <div class="school" @click="nav('school')">校园招聘</div>
        <div class="agency" @click="nav('agency')">社会招聘</div>
      </div>

      <div class="ball">
        <img src="../../assets/img/ball.png" alt />
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  mounted () {
    this.$nextTick(() => {
      this.$nextTick(() => {
        setTimeout(() => {
          window.parent.changeFrameHeight()
        }, 300)
      })
    })
  },
  methods: {
    nav (type) {
      this.$router.push({
        path: '/jobs/' + type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}
.recurit {
  width: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

// .pc {
//   display: none;
// }

.pc {
  display: block;
  .menu-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px auto 70px;

    .menu {
      margin-top: 20px;
      padding: 15px;
      background: #fff;
      box-shadow: 0 1px 1px #ddd;
      opacity: 1;
      transform: translate(0);
      transition: all 0.25s ease-in-out;

      &:hover {
        box-shadow: 0 0 40px #ddd;
      }

      .navImg {
        width: 100%;
        height: auto;
      }

      .nav-title {
        margin: 0 auto;
        margin-top: 20px;
        font-size: 32px;
        text-align: center;
      }

      .menu-btn {
        position: relative;
        margin: 20px auto 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 42px;
        background: #015198 none repeat scroll 0 0;
        text-align: center;
        color: #fff;
        z-index: 1;
        cursor: pointer;

        &:hover {
          &::before {
            width: 100%;
          }
        }

        &::before {
          position: absolute;
          content: "";
          top: 0;
          left: 0;
          width: 3px;
          height: 100%;
          transition: all 0.2s linear;
          background: #2196f3;
          z-index: -1;
        }
      }
    }
  }
}

// .mobile {
//   display: flex;
//   flex-direction: column;
//   position: relative;
//   padding-top: 15vw;
//   min-height: 613px;
//   background: url("../../assets/img/mbg.jpg") center no-repeat;
//   background-size: cover;

//   .logo {
//     margin: 0 auto;
//     width: 60vw;
//   }

//   .fly {
//     position: absolute;
//     top: 1vw;
//     right: 2vw;
//     width: 15vw;
//   }

//   .enter-box {
//     padding: 5vw 0;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     flex: 1 0 0;
//   }

//   .school,
//   .agency {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: 60vw;
//     height: 12vw;
//     border-radius: 6vw;
//     background: #dc2f2f;
//     color: #fff;
//     font-weight: bold;
//   }

//   .agency {
//     margin-top: 4vw;
//   }
// }

.banner-m {
  display: block;
}

.banner-pc {
  display: none;
}

@media (min-width: 768px) {
  .pc {
    display: block !important;
  }

  .mobile {
    display: none;
  }

  .banner-pc {
    display: block;
  }

  .banner-m {
    display: none;
  }
}
</style>
